import { render, staticRenderFns } from "./modal5.vue?vue&type=template&id=376bd666"
import script from "./modal5.vue?vue&type=script&lang=js"
export * from "./modal5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports